import { render, staticRenderFns } from "./ModularDetailsToggleOption.vue?vue&type=template&id=ec214e08"
import script from "./ModularDetailsToggleOption.vue?vue&type=script&lang=js"
export * from "./ModularDetailsToggleOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports